<template>
  <Modal :model-value="isOpen" title="Edit Personal Details" @update:model-value="$emit('close')">
    <div class="grid grid-cols-1 gap-3 sm:grid-cols-2">
      <div>
        <label class="mb-1 block text-xs font-semibold text-slate-700 dark:text-slate-300">First Name <span class="text-danger">*</span></label>
        <input
          v-model="localDraft.firstName"
          type="text"
          class="w-full rounded-xl px-4 py-3 text-sm bg-white/70 dark:bg-slate-900/40
                 border border-slate-200/60 dark:border-slate-700/60
                 text-slate-800 dark:text-slate-100
                 placeholder:text-slate-400 dark:placeholder:text-slate-500
                 shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2
                 focus:ring-offset-white dark:focus:ring-offset-slate-900
                 focus:ring-[#ff8e48]/60"
          required
        />
        <p v-if="!localDraft.firstName" class="mt-1 text-xs text-red-500">{{ requiredError }}</p>
      </div>
      <div>
        <label class="mb-1 block text-xs font-semibold text-slate-700 dark:text-slate-300">Last Name <span class="text-danger">*</span></label>
        <input
          v-model="localDraft.lastName"
          type="text"
          class="w-full rounded-xl px-4 py-3 text-sm bg-white/70 dark:bg-slate-900/40
                 border border-slate-200/60 dark:border-slate-700/60
                 text-slate-800 dark:text-slate-100
                 placeholder:text-slate-400 dark:placeholder:text-slate-500
                 shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2
                 focus:ring-offset-white dark:focus:ring-offset-slate-900
                 focus:ring-[#ff8e48]/60"
          required
        />
        <p v-if="!localDraft.lastName" class="mt-1 text-xs text-red-500">{{ requiredError }}</p>
      </div>
      <div>
        <label class="mb-1 block text-xs font-semibold text-slate-700 dark:text-slate-300">Username </label>
        <input
          v-model="localDraft.username"
          type="text"
          class="w-full rounded-xl px-4 py-3 text-sm bg-white/70 dark:bg-slate-900/40
                 border border-slate-200/60 dark:border-slate-700/60
                 text-slate-800 dark:text-slate-100
                 placeholder:text-slate-400 dark:placeholder:text-slate-500
                 shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2
                 focus:ring-offset-white dark:focus:ring-offset-slate-900
                 focus:ring-[#ff8e48]/60"
          required
        />
        <p v-if="!localDraft.username" class="mt-1 text-xs text-red-500">{{ requiredError }}</p>
        <p v-if="usernameError" class="mt-1 text-xs text-red-500">{{ usernameError }}</p>
      </div>
      <div>
        <label class="mb-1 block text-xs font-semibold text-slate-700 dark:text-slate-300">Gender</label>
        <select
          v-model="localDraft.gender"
          class="w-full rounded-xl px-4 py-3 text-sm bg-white/70 dark:bg-slate-900/40
                 border border-slate-200/60 dark:border-slate-700/60
                 text-slate-800 dark:text-slate-100
                 shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2
                 focus:ring-offset-white dark:focus:ring-offset-slate-900
                 focus:ring-[#ff8e48]/60"
        >
          <option value="">Select</option>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
          <option value="Prefer not to say">Prefer not to say</option>
        </select>
      </div>
      <div>
        <label class="mb-1 block text-xs font-semibold text-slate-700 dark:text-slate-300">Phone</label>
        <input
          v-model="localDraft.phone"
          type="text"
          class="w-full rounded-xl px-4 py-3 text-sm bg-white/70 dark:bg-slate-900/40
                 border border-slate-200/60 dark:border-slate-700/60
                 text-slate-800 dark:text-slate-100
                 placeholder:text-slate-400 dark:placeholder:text-slate-500
                 shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2
                 focus:ring-offset-white dark:focus:ring-offset-slate-900
                 focus:ring-[#ff8e48]/60"
        />
      </div>
      <div>
        <label class="mb-1 block text-xs font-semibold text-slate-700 dark:text-slate-300">Date of Birth</label>
        <input
          v-model="localDraft.dateOfBirth"
          type="date"
          class="w-full rounded-xl px-4 py-3 text-sm bg-white/70 dark:bg-slate-900/40
                 border border-slate-200/60 dark:border-slate-700/60
                 text-slate-800 dark:text-slate-100
                 placeholder:text-slate-400 dark:placeholder:text-slate-500
                 shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2
                 focus:ring-offset-white dark:focus:ring-offset-slate-900
                 focus:ring-[#ff8e48]/60"
        />
      </div>
      <div>
        <label class="mb-1 block text-xs font-semibold text-slate-700 dark:text-slate-300">Address</label>
        <input
          v-model="localDraft.address"
          type="text"
          class="w-full rounded-xl px-4 py-3 text-sm bg-white/70 dark:bg-slate-900/40
                 border border-slate-200/60 dark:border-slate-700/60
                 text-slate-800 dark:text-slate-100
                 placeholder:text-slate-400 dark:placeholder:text-slate-500
                 shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2
                 focus:ring-offset-white dark:focus:ring-offset-slate-900
                 focus:ring-[#ff8e48]/60"
        />
      </div>
      <div>
        <label class="mb-1 block text-xs font-semibold text-slate-700 dark:text-slate-300">Position</label>
        <select
          v-model="localDraft.positionId"
          class="w-full rounded-xl px-4 py-3 text-sm bg-white/70 dark:bg-slate-900/40
                 border border-slate-200/60 dark:border-slate-700/60
                 text-slate-800 dark:text-slate-100
                 shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2
                 focus:ring-offset-white dark:focus:ring-offset-slate-900
                 focus:ring-[#ff8e48]/60"
        >
          <option :value="null">Select position</option>
          <option v-for="pos in props.positions" :key="pos.id" :value="pos.id">{{ pos.name }}</option>
        </select>
      </div>
      <div>
        <label class="mb-1 block text-xs font-semibold text-slate-700 dark:text-slate-300">City</label>
        <input
          v-model="localDraft.city"
          type="text"
          class="w-full rounded-xl px-4 py-3 text-sm bg-white/70 dark:bg-slate-900/40
                 border border-slate-200/60 dark:border-slate-700/60
                 text-slate-800 dark:text-slate-100
                 placeholder:text-slate-400 dark:placeholder:text-slate-500
                 shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2
                 focus:ring-offset-white dark:focus:ring-offset-slate-900
                 focus:ring-[#ff8e48]/60"
        />
      </div>
      <div>
        <label class="mb-1 block text-xs font-semibold text-slate-700 dark:text-slate-300">State</label>
        <select
          v-model="localDraft.state"
          class="w-full rounded-xl px-4 py-3 text-sm bg-white/70 dark:bg-slate-900/40
                 border border-slate-200/60 dark:border-slate-700/60
                 text-slate-800 dark:text-slate-100
                 shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2
                 focus:ring-offset-white dark:focus:ring-offset-slate-900
                 focus:ring-[#ff8e48]/60"
        >
          <option value="">Select state</option>
          <option value="Alabama">Alabama</option>
          <option value="Alaska">Alaska</option>
          <option value="Arizona">Arizona</option>
          <option value="Arkansas">Arkansas</option>
          <option value="California">California</option>
          <option value="Colorado">Colorado</option>
          <option value="Connecticut">Connecticut</option>
          <option value="Delaware">Delaware</option>
          <option value="Florida">Florida</option>
          <option value="Georgia">Georgia</option>
          <option value="Hawaii">Hawaii</option>
          <option value="Idaho">Idaho</option>
          <option value="Illinois">Illinois</option>
          <option value="Indiana">Indiana</option>
          <option value="Iowa">Iowa</option>
          <option value="Kansas">Kansas</option>
          <option value="Kentucky">Kentucky</option>
          <option value="Louisiana">Louisiana</option>
          <option value="Maine">Maine</option>
          <option value="Maryland">Maryland</option>
          <option value="Massachusetts">Massachusetts</option>
          <option value="Michigan">Michigan</option>
          <option value="Minnesota">Minnesota</option>
          <option value="Mississippi">Mississippi</option>
          <option value="Missouri">Missouri</option>
          <option value="Montana">Montana</option>
          <option value="Nebraska">Nebraska</option>
          <option value="Nevada">Nevada</option>
          <option value="New Hampshire">New Hampshire</option>
          <option value="New Jersey">New Jersey</option>
          <option value="New Mexico">New Mexico</option>
          <option value="New York">New York</option>
          <option value="North Carolina">North Carolina</option>
          <option value="North Dakota">North Dakota</option>
          <option value="Ohio">Ohio</option>
          <option value="Oklahoma">Oklahoma</option>
          <option value="Oregon">Oregon</option>
          <option value="Pennsylvania">Pennsylvania</option>
          <option value="Rhode Island">Rhode Island</option>
          <option value="South Carolina">South Carolina</option>
          <option value="South Dakota">South Dakota</option>
          <option value="Tennessee">Tennessee</option>
          <option value="Texas">Texas</option>
          <option value="Utah">Utah</option>
          <option value="Vermont">Vermont</option>
          <option value="Virginia">Virginia</option>
          <option value="Washington">Washington</option>
          <option value="West Virginia">West Virginia</option>
          <option value="Wisconsin">Wisconsin</option>
          <option value="Wyoming">Wyoming</option>
        </select>
      </div>
      <div>
        <label class="mb-1 block text-xs font-semibold text-slate-700 dark:text-slate-300">Zip Code</label>
        <input
          v-model="localDraft.zipcode"
          type="text"
          class="w-full rounded-xl px-4 py-3 text-sm bg-white/70 dark:bg-slate-900/40
                 border border-slate-200/60 dark:border-slate-700/60
                 text-slate-800 dark:text-slate-100
                 placeholder:text-slate-400 dark:placeholder:text-slate-500
                 shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2
                 focus:ring-offset-white dark:focus:ring-offset-slate-900
                 focus:ring-[#ff8e48]/60"
        />
      </div>
    </div>

    <template #footer>
      <button
        type="button"
        class="inline-flex items-center justify-center rounded-xl border bg-danger px-4 py-2 text-sm font-semibold text-white hover:bg-slate-700"
        @click="$emit('close')"
      >
        Cancel
      </button>
      <button
        type="button"
        class="inline-flex items-center justify-center rounded-xl bg-primary hover:bg-secondary px-4 py-2 text-sm font-semibold text-white
               shadow-sm hover:brightness-110 transition disabled:cursor-not-allowed disabled:opacity-60"
        :disabled="loading || !isValid"
        @click="handleSave"
      >
        Save
      </button>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { reactive, computed, watch } from 'vue'
import Modal from '@/components/layout/Modal.vue'

interface Draft {
  firstName: string
  lastName: string
  username: string
  dateOfBirth: string
  gender: string
  address: string
  city: string
  state: string
  zipcode: string
  phone: string
  email: string
  positionId: number | null
}

import type { Position } from '@/services/positionService'

const props = defineProps<{
  isOpen: boolean
  draft: Draft
  loading: boolean
  positions: Position[]
}>()

const emit = defineEmits<{
  (e: 'close'): void
  (e: 'save', draft: Draft): void
}>()

// Create a local reactive copy of the draft
const localDraft = reactive<Draft>({ ...props.draft })

// When modal opens, re-initialize ALL fields from props to ensure cancel reverts to original values
// This is the ONLY time we sync from parent to child - prevents field shifting during editing
watch(() => props.isOpen, (isOpen) => {
  if (isOpen) {
    localDraft.firstName = props.draft.firstName
    localDraft.lastName = props.draft.lastName
    localDraft.username = props.draft.username
    localDraft.dateOfBirth = props.draft.dateOfBirth
    localDraft.gender = props.draft.gender
    localDraft.address = props.draft.address
    localDraft.city = props.draft.city
    localDraft.state = props.draft.state
    localDraft.zipcode = props.draft.zipcode
    localDraft.phone = props.draft.phone
    localDraft.email = props.draft.email
    localDraft.positionId = props.draft.positionId
  }
})

const requiredError = computed(() => {
  if (!localDraft.firstName) {
    return 'First name is required'
  }
  else if (!localDraft.lastName) {
    return 'Last name is required'
  }
  else if (!localDraft.username) {
    return 'Username is required'
  }
  return ''
})

// Username validation: check if username contains spaces
const usernameError = computed(() => {
  if (localDraft.username && localDraft.username.includes(' ')) {
    return 'Username cannot contain spaces'
  }
  return ''
})

const isValid = computed(() => {
  return !usernameError.value
})

const handleSave = () => {
  if (isValid.value) {
    emit('save', { ...localDraft })
  }
}
</script>
